export const DAY_KEYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const DAYS = [
    { key: 'Mon', label: 'Lun.', fullName: 'Lunes', index: 0 },
    { key: 'Tue', label: 'Mar.', fullName: 'Martes', index: 1 },
    { key: 'Wed', label: 'Miér.', fullName: 'Miércoles', index: 2 },
    { key: 'Thu', label: 'Jue.', fullName: 'Jueves', index: 3 },
    { key: 'Fri', label: 'Vie.', fullName: 'Viernes', index: 4 },
    { key: 'Sat', label: 'Sáb.', fullName: 'Sábado', index: 5 },
    { key: 'Sun', label: 'Dom.', fullName: 'Domingo', index: 6 },
];
const keyToLabel = {
    Mon: 'Lun.', Tue: 'Mar.', Wed: 'Miér.',
    Thu: 'Jue.', Fri: 'Vie.', Sat: 'Sáb.', Sun: 'Dom.',
};
const labelToKey = {
    'Lun.': 'Mon', 'Mar.': 'Tue', 'Miér.': 'Wed',
    'Jue.': 'Thu', 'Vie.': 'Fri', 'Sáb.': 'Sat', 'Dom.': 'Sun',
};
const keyToFullName = {
    Mon: 'Lunes', Tue: 'Martes', Wed: 'Miércoles',
    Thu: 'Jueves', Fri: 'Viernes', Sat: 'Sábado', Sun: 'Domingo',
};
const fullNameToKey = {
    'Lunes': 'Mon', 'Martes': 'Tue', 'Miércoles': 'Wed',
    'Jueves': 'Thu', 'Viernes': 'Fri', 'Sábado': 'Sat', 'Domingo': 'Sun',
};
const keyToIndex = {
    Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6,
};
export const DayOfWeek = {
    keys: DAY_KEYS,
    all: DAYS,
    toLabel(key) {
        return keyToLabel[key];
    },
    toFullName(key) {
        return keyToFullName[key];
    },
    fromLabel(label) {
        return labelToKey[label];
    },
    fromFullName(name) {
        return fullNameToKey[name];
    },
    getIndex(key) {
        return keyToIndex[key];
    },
    fromIndex(index) {
        if (index < 0 || index > 6)
            return undefined;
        return DAY_KEYS[index];
    },
    keysToLabels(keys) {
        return keys.map((key) => keyToLabel[key]);
    },
    labelsToKeys(labels) {
        return labels
            .map((label) => labelToKey[label])
            .filter((key) => key !== undefined);
    },
    getRange(start, end) {
        const startIndex = keyToIndex[start];
        const endIndex = keyToIndex[end];
        if (startIndex <= endIndex) {
            return DAY_KEYS.slice(startIndex, endIndex + 1);
        }
        else {
            return [
                ...DAY_KEYS.slice(startIndex),
                ...DAY_KEYS.slice(0, endIndex + 1),
            ];
        }
    },
    formatRange(start, end) {
        const startName = keyToFullName[start];
        const endName = keyToFullName[end];
        if (start === end) {
            return startName;
        }
        return `${startName} a ${endName.toLowerCase()}`;
    },
    formatRangeShort(start, end) {
        const startLabel = keyToLabel[start];
        const endLabel = keyToLabel[end];
        if (start === end) {
            return startLabel;
        }
        return `${startLabel} a ${endLabel.toLowerCase()}`;
    },
    isValidKey(value) {
        return DAY_KEYS.includes(value);
    },
    isValidLabel(value) {
        return value in labelToKey;
    },
    legacy: keyToFullName,
};
/** @deprecated Use DayOfWeek.toFullName() instead */
export const DaysOfWeek = keyToFullName;
export default DayOfWeek;
